import { render } from "./FilterDistributorAll.vue?vue&type=template&id=5e960cbc"
import script from "./FilterDistributorAll.vue?vue&type=script&lang=js"
export * from "./FilterDistributorAll.vue?vue&type=script&lang=js"
script.render = render

export default script